// extracted by mini-css-extract-plugin
module.exports = {"root":"HEBNfrym","medium":"ovAkW2i7","large":"s6X4wMbO","image":"_9xxk8zeV"};